import { render, staticRenderFns } from "./product_price_maintain.vue?vue&type=template&id=56915fee"
import script from "./product_price_maintain.vue?vue&type=script&lang=js"
export * from "./product_price_maintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56915fee')) {
      api.createRecord('56915fee', component.options)
    } else {
      api.reload('56915fee', component.options)
    }
    module.hot.accept("./product_price_maintain.vue?vue&type=template&id=56915fee", function () {
      api.rerender('56915fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_price_maintain/product_price_maintain.vue"
export default component.exports